/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse }             from '@angular/common/http';
import { Observable, throwError }                            from 'rxjs';
import { catchError, map }                                   from 'rxjs/operators';

import * as models                                           from '../model/models';
import { COLLECTION_FORMATS }                                from '../variables';
import { ApiConfiguration }                                  from '../configuration';
import { ModelRegistry, PagedArray, LoggerService }          from '../../common';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class ShowsApi {
    protected basePath = '';
    public defaultHeaders: Record<string,string> = {};
    public configuration: ApiConfiguration = new ApiConfiguration();

    constructor(
        protected http: HttpClient, 
        @Optional() configuration: ApiConfiguration,
        protected logger: LoggerService
    ) {
        if (configuration) {
            this.configuration = configuration;
        }

        if (configuration && configuration.basePath)
            this.basePath = configuration.basePath;
    }

    /**
     * 
     * 
     * @param id 
     * @param offset 
     * @param limit 
     */
    public getShowArticles(id?: string, offset?: number, limit?: number, __unused?: any): Observable<PagedArray<models.ApiAbbreviatedArticle>> {
        return this.getShowArticlesRequest(id, offset, limit, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('AbbreviatedArticle', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type AbbreviatedArticle`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type AbbreviatedArticle`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     * @param offset 
     * @param limit 
     */
    public getShowClips(id?: string, offset?: number, limit?: number, __unused?: any): Observable<PagedArray<models.ApiAbbreviatedProduction>> {
        return this.getShowClipsRequest(id, offset, limit, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('AbbreviatedProduction', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type AbbreviatedProduction`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type AbbreviatedProduction`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     * @param offset 
     * @param limit 
     */
    public getShowProductions(id?: string, offset?: number, limit?: number, __unused?: any): Observable<PagedArray<models.ApiAbbreviatedProduction>> {
        return this.getShowProductionsRequest(id, offset, limit, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('AbbreviatedProduction', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type AbbreviatedProduction`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type AbbreviatedProduction`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     * @param offset 
     * @param limit 
     */
    public getShowPodcasts(id?: string, offset?: number, limit?: number, __unused?: any): Observable<PagedArray<models.ApiAbbreviatedProduction>> {
        return this.getShowPodcastsRequest(id, offset, limit, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('AbbreviatedProduction', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type AbbreviatedProduction`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type AbbreviatedProduction`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     * @param offset 
     * @param limit 
     */
    public getShowEpisodes(id?: string, offset?: number, limit?: number, __unused?: any): Observable<PagedArray<models.ApiAbbreviatedProduction>> {
        return this.getShowEpisodesRequest(id, offset, limit, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('AbbreviatedProduction', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type AbbreviatedProduction`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type AbbreviatedProduction`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     */
    public get(id?: string, __unused?: any): Observable<models.ApiShow> {
        return this.getRequest(id, __unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('Show', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type Show`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type Show`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public all(__unused?: any): Observable<PagedArray<models.ApiShow>> {
        return this.allRequest(__unused)
            .pipe(
                catchError(e => {
                    // e has keys like _body,status,ok,statusText,headers,type,url
                    if (e.status === 0 || e.status === 500 || e.status === 504) {
                        return throwError({
                            message: 'A network error has occurred.',
                            requestDetails: {
                                status: e.status,
                                statusText: e.statusText,
                                url: e.url,
                                headers: e.headers
                            },
                            error: true, 
                            errorType: 'network-error', 
                            json: function() { return this; }
                        });
                    }

                    return throwError(e);
                }),
                map(response => {
                    if (response.status === 204) {
                        return undefined;
                    } else {
                        let rawData = response.body;
                        
                        let expandedModel : any;
                        try {
                            expandedModel = ModelRegistry.inflate('Show', rawData);
                        } catch (e) {
                            console.error(`Failed while expanding API data into model of type Show`);
                            console.log(`Raw data:`);
                            console.dir(rawData);
                            console.error(e);
                            throw new Error(`Failed to expand model data with type Show`);
                        }

                        if (expandedModel instanceof Array) {
                            if (response.headers.get('X-Total'))
                                expandedModel['total'] = response.headers.get('X-Total');
                            else if (response.headers.get('X-TYT-Total'))
                                expandedModel['total'] = response.headers.get('X-TYT-Total');
                        }

                        if (response.headers.get('X-TYT-Authentication'))
                            expandedModel['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                        return expandedModel;
                    }
                })
            )
        ;
    }


    /**
     * 
     * 
     * @param id 
     * @param offset 
     * @param limit 
     */
    public getShowArticlesRequest(id?: string, offset?: number, limit?: number, extraHttpRequestParams?: any): Observable<HttpResponse<PagedArray<models.ApiAbbreviatedArticle>>> {
        const path = this.basePath + '/content/shows/{id}/feed/articles'
                    .replace('{' + 'id' + '}', String(id));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        if (offset !== undefined) {
            queryParameters['offset'] = <any>offset;
        }

        if (limit !== undefined) {
            queryParameters['limit'] = <any>limit;
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<PagedArray<models.ApiAbbreviatedArticle>>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     * @param offset 
     * @param limit 
     */
    public getShowClipsRequest(id?: string, offset?: number, limit?: number, extraHttpRequestParams?: any): Observable<HttpResponse<PagedArray<models.ApiAbbreviatedProduction>>> {
        const path = this.basePath + '/content/shows/{id}/feed/clips'
                    .replace('{' + 'id' + '}', String(id));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        if (offset !== undefined) {
            queryParameters['offset'] = <any>offset;
        }

        if (limit !== undefined) {
            queryParameters['limit'] = <any>limit;
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<PagedArray<models.ApiAbbreviatedProduction>>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     * @param offset 
     * @param limit 
     */
    public getShowProductionsRequest(id?: string, offset?: number, limit?: number, extraHttpRequestParams?: any): Observable<HttpResponse<PagedArray<models.ApiAbbreviatedProduction>>> {
        const path = this.basePath + '/content/shows/{id}/feed/all'
                    .replace('{' + 'id' + '}', String(id));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        if (offset !== undefined) {
            queryParameters['offset'] = <any>offset;
        }

        if (limit !== undefined) {
            queryParameters['limit'] = <any>limit;
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<PagedArray<models.ApiAbbreviatedProduction>>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     * @param offset 
     * @param limit 
     */
    public getShowPodcastsRequest(id?: string, offset?: number, limit?: number, extraHttpRequestParams?: any): Observable<HttpResponse<PagedArray<models.ApiAbbreviatedProduction>>> {
        const path = this.basePath + '/content/shows/{id}/feed/podcasts'
                    .replace('{' + 'id' + '}', String(id));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        if (offset !== undefined) {
            queryParameters['offset'] = <any>offset;
        }

        if (limit !== undefined) {
            queryParameters['limit'] = <any>limit;
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<PagedArray<models.ApiAbbreviatedProduction>>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     * @param offset 
     * @param limit 
     */
    public getShowEpisodesRequest(id?: string, offset?: number, limit?: number, extraHttpRequestParams?: any): Observable<HttpResponse<PagedArray<models.ApiAbbreviatedProduction>>> {
        const path = this.basePath + '/content/shows/{id}/feed/episodes'
                    .replace('{' + 'id' + '}', String(id));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        if (offset !== undefined) {
            queryParameters['offset'] = <any>offset;
        }

        if (limit !== undefined) {
            queryParameters['limit'] = <any>limit;
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<PagedArray<models.ApiAbbreviatedProduction>>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     */
    public getRequest(id?: string, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiShow>> {
        const path = this.basePath + '/content/shows/{id}'
                    .replace('{' + 'id' + '}', String(id));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiShow>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public allRequest(extraHttpRequestParams?: any): Observable<HttpResponse<PagedArray<models.ApiShow>>> {
        const path = this.basePath + '/content/shows';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        // oauth required
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
        
        // https://github.com/swagger-api/swagger-codegen/issues/4037

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<PagedArray<models.ApiShow>>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${e.status} ${e.statusText}`);
                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

}
